export function LogoMark({ size = 28, className = "" }) {
    return (
        <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} aria-hidden="true">
            <path d="M4 12V4h8M28 4h8v8M36 28v8h-8M12 36H4v-8" stroke="currentColor" strokeWidth="3.5" />
            <circle cx="20" cy="20" r="6" fill="currentColor" />
        </svg>
    );
}
